import type { SVGProps } from "react";
import React from "react";

export const SuccessIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 20,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2237 0.206786C17.4243 0.396522 17.4331 0.712981 17.2434 0.913617L6.9734 11.7736C6.88062 11.8717 6.75211 11.9281 6.6171 11.93C6.48208 11.9319 6.35204 11.8791 6.25656 11.7836L0.766564 6.29362C0.571302 6.09836 0.571302 5.78178 0.766564 5.58652C0.961826 5.39125 1.27841 5.39125 1.47367 5.58652L6.60011 10.713L16.5168 0.226522C16.7066 0.025886 17.023 0.0170497 17.2237 0.206786Z"
      fill="#1D1D1B"
    />
  </svg>
);
